// extracted by mini-css-extract-plugin
export default {"rolesRow":"editor_rolesRow__wulro","title":"editor_title__M7xkg","rolesGrouptitle":"editor_rolesGrouptitle__SBJr0","rolesItems":"editor_rolesItems__j76Lc"};